'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseBus = require('./base-bus.js');
var payloadMismatchError = require('./payload-mismatch-error.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const logCss = "background-color: darkgreen; color: white";
exports.PendingQueryTimeoutInMs = 1e4;
class QueryBus extends baseBus.BaseBus {
  constructor() {
    super(...arguments);
    this._pendingQueries = new Map();
    this._pendingTimeouts = new Map();
  }
  subscribe(channel, callback) {
    if (typeof callback !== "function") {
      throw new Error("Callback function must be supplied as the second argument.");
    }
    if (!!this.getHandler(channel)) {
      throw new Error(`Handler for this query already registered (channel = ${channel}).`);
    }
    this.logRegisteredHandler(channel);
    this.setHandler(channel, callback);
    if (this._pendingQueries.has(channel)) {
      this.logPendingQueries(channel);
      this.resolvePendingQueries(channel);
    }
    return this.getSubscription(channel);
  }
  query(channel, param2, param3) {
    const payload = typeof param2 !== "function" ? param2 : void 0;
    const callback = typeof param3 !== "undefined" ? param3 : typeof param2 === "function" ? param2 : void 0;
    if (callback && typeof callback !== "function") {
      throw new Error("Callback provided is not a function.");
    }
    if (!this.getHandler(channel)) {
      this.logPendingQuery(channel, payload);
      return this.savePendingQuery(channel, payload, callback);
    }
    const schema = this.getSchema(channel);
    if (this.isPayloadInvalid(channel, payload)) {
      throw new payloadMismatchError.PayloadMismatchError(channel, schema, payload);
    }
    this.logQuery(channel, payload);
    this.setLatest(channel, payload);
    const handlerResult = this.resolveHandler(channel, payload);
    return callback ? handlerResult.then(callback) : handlerResult;
  }
  overridePendingQueryTimeoutInMs(timeoutInMs) {
    exports.PendingQueryTimeoutInMs = timeoutInMs;
  }
  getHandler(channel) {
    var _a;
    return (_a = this._subscriptions.get(channel)) == null ? void 0 : _a.handler;
  }
  setHandler(channel, callback) {
    if (!this._subscriptions.has(channel)) {
      this.initChannel(channel);
    }
    this._subscriptions.get(channel).handler = callback;
  }
  resolveHandler(channel, payload) {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      try {
        const result = yield this.getHandler(channel)({
          channel,
          payload
        });
        resolve(result);
      } catch (e) {
        reject(e);
      }
    }));
  }
  getSubscription(channel) {
    return {
      unsubscribe: () => delete this._subscriptions.get(channel).handler
    };
  }
  savePendingQuery(channel, payload, callback) {
    if (!this._pendingQueries.has(channel)) {
      this._pendingQueries.set(channel, []);
      this.initPendingQueryTimer(channel);
    }
    if (callback) {
      this._pendingQueries.get(channel).push({ payload, resolve: callback });
    } else {
      const entry = { payload };
      const promise = new Promise((resolve, reject) => {
        entry.resolve = resolve;
        entry.reject = reject;
      });
      this._pendingQueries.get(channel).push(entry);
      return promise;
    }
  }
  initPendingQueryTimer(channel) {
    this._pendingTimeouts.set(channel, setTimeout(() => {
      const entries = this._pendingQueries.get(channel);
      entries.forEach((entry) => {
        var _a;
        (_a = entry.reject) == null ? void 0 : _a.call(entry, new Error(`Pending query for more than ${exports.PendingQueryTimeoutInMs / 1e3} seconds, channel = ${channel}, payload = ${JSON.stringify(entry.payload)}`));
      });
      this._pendingQueries.delete(channel);
    }, exports.PendingQueryTimeoutInMs));
  }
  resolvePendingQueries(channel) {
    clearTimeout(this._pendingTimeouts.get(channel));
    this._pendingTimeouts.delete(channel);
    this._pendingQueries.get(channel).forEach((entry) => __async(this, null, function* () {
      var _a;
      try {
        const result = yield this.resolveHandler(channel, entry.payload);
        entry.resolve(result);
      } catch (e) {
        (_a = entry.reject) == null ? void 0 : _a.call(entry, e);
      }
    }));
    this._pendingQueries.delete(channel);
  }
  logRegisteredHandler(channel) {
    this.log("%cQuery bus: registered handler for channel", logCss, channel);
  }
  logPendingQuery(channel, payload) {
    this.log("%cQuery bus: handler is missing for channel", logCss, channel);
    this.log("%cQuery bus: saving query with payload", logCss, payload);
  }
  logQuery(channel, payload) {
    this.log("%cQuery bus: resolving query for channel", logCss, channel);
    this.log("%cQuery bus: query payload", logCss, payload);
  }
  logPendingQueries(channel) {
    this.log("%cQuery bus: resolving pending queries for channel", logCss, channel);
    this.log("%cQuery bus: pending payloads", logCss, Array.from(this._pendingQueries.values()));
  }
}

exports.QueryBus = QueryBus;
